/**
 * Returns the configured routes for the application.
 *
 * @returns {React.Element} The routes for the application.
 */
import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import Page404 from './pages/Page404';
import ProjectPage from './pages/ProjectPage';
import CreateProjectPage from './pages/CreateProjectPage';
import UserPage from './pages/UserPage';
import CreateUserPage from './pages/CreateUserPage';
import Chat from './pages/chat/Chat';
import KnowledgeChat from './pages/chat/KnowledgeChat';
import Login from './pages/login/Login';
import useToken from './pages/login/useToken';
import DataLoader from './pages/DataLoader';
import DashboardAppPage from './pages/DashboardAppPage';
import DashboardPage from './pages/dashboard';
import Settings from './pages/settings';
// ----------------------------------------------------------------------

/**
 * Router component for handling application routes.
 *
 * @returns {ReactNode} The rendered routes.
 */
export default function Router() {
  const { setToken, token } = useToken();
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/chat" />, index: true },
        { path: 'analytics', element: <DashboardPage /> },
        { path: 'project', element: <ProjectPage /> },
        { path: 'create-project', element: <CreateProjectPage /> },
        { path: 'edit-project/:projectId', element: <CreateProjectPage /> },
        { path: 'create-user', element: <CreateUserPage /> },
        { path: 'user', element: <UserPage /> },
        { path: 'chat', element: <KnowledgeChat />, children: [{ path: ':sessionId', element: <KnowledgeChat /> }] },
        { path: 'dataloader', element: <DataLoader /> },
        { path: 'settings', element: <Settings /> },
      ],
    },
    // {
    //   element: <SimpleLayout />,
    //   children: [
    //     { element: <Navigate to="/dashboard" />, index: true },
    //     { path: '404', element: <Page404 /> },
    //     { path: '*', element: <Navigate to="/404" /> },
    //   ],
    // },
    {
      path: '*',
      element: <Navigate to="/dashboard" />,
      // <Navigate to="/404" replace />,
    },
  ]);
  return routes;
}
// }
